import React from 'react';
import { Link } from 'react-router-dom';

import Background from '../../components/Background';
import Header from '../../components/Header';

import { Container, Content, Wrapper } from './styles';
import Cases from '../../components/Cases';

const Home: React.FC = () => (
  <Wrapper>
    <Container>
      <Background />
      <Header />

      <Content>
        <h1>
          Designing
          <span> differentiation </span>
          for innovators.
        </h1>

        <p>
          Developing top class mobile friendly websites with outstanding design
          and right content approach.
        </p>

        <Link to="/about" className="button">
          about us
        </Link>
      </Content>
    </Container>

    <Cases />
  </Wrapper>
);

export default Home;
